import tree from '../state';
import * as faqService from '../services/faqService';

export const enterFaqAction = ({ params }, replace, callback) => {
    tree.set('loading', true);
    faqService.getfaqs().then(faqs => {
        tree.set('faqs', faqs);
        tree.set('loading', false);
        callback();
    });
};



// WEBPACK FOOTER //
// ./src/actions/faqActions.js